function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76.8752 7H3.12501C1.40188 7 0 8.40188 0 10.125V14.0313C0 15.1849 0.630001 16.192 1.5625 16.7335V62.4689C1.5625 63.6225 2.1925 64.6296 3.12501 65.1711V71.0626C3.12501 71.9256 3.82454 72.6251 4.68751 72.6251H75.3127C76.1755 72.6251 76.8752 71.9256 76.8752 71.0626V65.1711C77.8075 64.6296 78.4375 63.6226 78.4375 62.469V16.7335C79.37 16.192 80 15.1849 80 14.0313V10.125C80.0002 8.40172 78.5983 7 76.8752 7ZM76.8752 10.1249V14.0311H3.12501L3.12469 10.1249H76.8752ZM75.3127 62.4689H41.5626V51.5317C41.5626 50.6687 40.8629 49.9692 40.0001 49.9692C39.1373 49.9692 38.4376 50.6687 38.4376 51.5317V62.4689H4.68907C4.6886 62.4689 4.68813 62.4689 4.68751 62.4689V17.1563H38.4376V37.469C38.4376 38.3319 39.1371 39.0315 40.0001 39.0315C40.8631 39.0315 41.5626 38.3319 41.5626 37.469V17.1563H75.3127V62.4689ZM6.25001 69.5001V65.5939H73.7501V69.5001H6.25001Z",
  fill: "#E77F67"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.2502 39.0313H52.5003C53.3631 39.0313 54.0628 38.3318 54.0628 37.4688V21.8438C54.0628 20.9808 53.3631 20.2812 52.5003 20.2812H46.2502C45.3874 20.2812 44.6877 20.9808 44.6877 21.8438V37.4688C44.6877 38.3318 45.3874 39.0313 46.2502 39.0313ZM47.8128 23.4061H50.9378V35.9061H47.8128V23.4061Z",
  fill: "#E77F67"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.75 20.2812H27.5C26.637 20.2812 25.9375 20.9808 25.9375 21.8438V37.4688C25.9375 38.3318 26.637 39.0313 27.5 39.0313H33.75C34.613 39.0313 35.3125 38.3318 35.3125 37.4688V21.8438C35.3125 20.9808 34.6128 20.2812 33.75 20.2812ZM32.1875 35.9064H29.0625V23.4064H32.1875V35.9064Z",
  fill: "#E77F67"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40 42.9375C39.137 42.9375 38.4375 43.6375 38.4375 44.5005C38.4375 45.3634 39.137 46.063 40 46.063C40.863 46.063 41.5625 45.3634 41.5625 44.5005V44.4994C41.5625 43.6364 40.863 42.9375 40 42.9375Z",
  fill: "#E77F67"
});

var SvgCloset = function SvgCloset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closet.123d7184.svg";
export { ForwardRef as ReactComponent };